import { useEffect } from 'react'
import { type SveaOrder } from 'ecosystem'
import { useDispatch, useSelector } from 'shared-redux'
import { cleanCart, selectedCart } from 'shared-redux/state'
import { SveaCheckout } from '../SveaCheckout'

interface SveaConfirmationProps {
  sveaData: SveaOrder
  onConfirmPurchase: () => void
}

export const SveaConfirmation = ({ sveaData, onConfirmPurchase }: SveaConfirmationProps) => {
  const dispatch = useDispatch()
  const { cartStateUuid } = useSelector(selectedCart)

  useEffect(() => {
    if (sveaData.Status !== 'Final') {
      return
    }

    onConfirmPurchase()
  }, [onConfirmPurchase, sveaData.Status])

  // Clean cart after payment confirmation, only if the cart is the same as it was during checkout.
  useEffect(() => {
    if (sveaData.Status !== 'Final' || !cartStateUuid || !sveaData.MerchantData) {
      return
    }

    try {
      const merchantData = JSON.parse(sveaData.MerchantData) as { cartStateUuid: string | null }

      if (merchantData.cartStateUuid === cartStateUuid) {
        dispatch(cleanCart())
      }
    } catch {
      void 0
    }
  }, [cartStateUuid, dispatch, sveaData.MerchantData, sveaData.Status])

  return <SveaCheckout sveaOrder={sveaData} />
}
